import { Outlet } from "react-router-dom";
// @mui
import { styled } from "@mui/material/styles";
// components
import Logo from "../components/Logo";
import { Box, IconButton, Tooltip } from "@mui/material";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

const HeaderStyle = styled("header")(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: "100%",

  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(5, 5, 0),
  },
}));

// ----------------------------------------------------------------------

export default function LogoOnlyLayout() {
  const { currentLang, onChangeLang } = useLocales();

  return (
    <>
      <HeaderStyle>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Logo />
          <Tooltip title="Language">
            <IconButton
              onClick={() =>
                onChangeLang(currentLang.value === "ar" ? "en" : "ar")
              }
            >
              <Box
                component="img"
                src={
                  currentLang.value === "ar"
                    ? "/flags/ic_flag_en.svg"
                    : "/flags/ic_flag_sa.svg"
                }
              />
            </IconButton>
          </Tooltip>
        </Box>
      </HeaderStyle>
      <Outlet />
    </>
  );
}
